import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import collegeGradDesktopWebp from './images/college-grad-desktop.webp';
import collegeGradMobileWebp from './images/college-grad-mobile.webp';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='college-savings-plans-financial-planning'
      backgroundVariant='lightB'
      moduleName='college-savings-plans-module'
      moduleVariation='B'
      reverseContent={false}
      // content
      subHeadingText={<>How can Northwestern Mutual help with a <WidowBlock>college fund&#63;</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='button'>
            When you work with us, we see a college savings plan as one part of an overarching financial plan. We&#39;ll look at everything you have going on&#8212;your goals like saving for college, your needs, and your priorities. With your big picture in focus, we&#39;ll create a tailored plan to help you save, grow your money, and make sure everything&#39;s protected.
          </Typography>
          <Link
            variant='buttonLinkPrimary'
            id='college-savings-plans-financial-planning-fafa-cta'
            ariaLabel='Get matched with a financial advisor today'
            linkUrl= '/find-a-financial-advisor/'>
            Connect with an advisor
          </Link>
        </>
      )}
      // image props
      imageAltText='A young man in a graduation robe surrounded by his parents.'
      imageSrcDefault={collegeGradDesktopWebp.toString()}
      imageSrcMobile={collegeGradMobileWebp.toString()}
    />
  );
};
